import * as React from 'react'

import { Field } from 'redux-form'

import { Input, MaskedInput } from 'components'

const required = value => (value ? undefined : 'Required')

const email = value =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? 'Invalid email'
    : undefined

interface IProps {
  onChangeMaskedInput: any
}

export default (props: IProps) => {
  const { onChangeMaskedInput } = props

  return (
    <form className="add-educator-form" noValidate={true} autoComplete="off">
      <Field
        props={{
          label: 'Full Name'
        }}
        name="educatorFullName"
        type="text"
        component={Input}
        validate={[required]}
      />
      <Field
        props={{
          label: 'Email Address'
        }}
        name="educatorEmail"
        type="email"
        component={Input}
        validate={[required, email]}
      />
      <Field
        props={{
          label: 'School'
        }}
        name="school"
        type="text"
        component={Input}
        validate={[required]}
      />
      <Field
        props={{
          label: 'Phone',
          onChangeMaskedInput: value => onChangeMaskedInput('phone', value)
        }}
        name="phone"
        type="text"
        component={MaskedInput}
        validate={[required]}
      />
    </form>
  )
}



// WEBPACK FOOTER //
// ./src/pages/AddPatient/educatorForm.tsx